export default __webpack_public_path__ + "static/exchange-72984efd3c57f899355117e9e3e71137.mp4";